import React from 'react';
import { Stack } from '@/Components/ui/layout';
import { Heading, Text } from '@/Components/ui/typography';
import { Input } from '@/Components/ui/input';

function Website({ websites, setWebsites }) {
  const handleChange = (e) => {
    const { value } = e.target;
    setWebsites({
      website: value
    });
  };

  return (
    <section className="flex flex-col items-center -mt-5 w-full p-5 ml-1">
      <div className="text-center mb-5">
        <Heading level="h2" size="2xl" className="font-bold text-slate-400 -ml-[1020px] mb-0">
          Website
        </Heading>
        <Text size="lg" className="text-slate-400 -mt-1.5 -ml-[685px]">
          Add a link that will appear at the top of your profile.
        </Text>
      </div>
      <div className="flex gap-2.5 mt-5 w-[30%] max-w-[600px] -ml-[500px] -mt-5">
        <Input
          type="text"
          id="website"
          name="website"
          placeholder="Enter website URL"
          value={websites.website || ''}
          onChange={handleChange}
          className="w-full py-3 px-3 rounded-lg border border-slate-700 bg-transparent text-slate-400 text-base -ml-[130px]"
        />
      </div>
    </section>
  );
}

export default Website;
